export default __webpack_public_path__ + "static/media/icon-CAD.189a5d8b.svg";